import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Building2, Loader2 } from 'lucide-react';

export default function Login() {
  const { login, isLoading, user, isAuthenticated } = useAuth();
  const { accounts } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    // ✅ FIX: Only redirect after FULL authentication (MSAL + backend validation)
    // Wait for both MSAL account AND backend user data to be available
    // This prevents race condition where navigation happens before backend call completes
    if (accounts.length > 0 && user && isAuthenticated) {
     
      navigate('/');
    }
  }, [accounts, user, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <Card className="w-[400px]">
        <CardHeader className="space-y-1 text-center">
          <div className="flex justify-center mb-4">
            <Building2 className="h-12 w-12 text-primary" />
          </div>
          <CardTitle className="text-2xl font-bold">Contract Management</CardTitle>
          <CardDescription>
            Sign in with your Microsoft 365 account
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button
            onClick={login}
            className="w-full"
            size="lg"
          >
            Sign in with Microsoft
          </Button>
          <p className="text-xs text-center text-muted-foreground mt-4">
            Single Sign-On with Azure Entra ID
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
